module.exports = __webpack_public_path__ + "static/cortex-value-spending-min-22b32894fe2236bc5705f329adc4de60.png";